export default __webpack_public_path__ + "img/84361378d6915ae331757fce882aa686.jpg";